export const PROTECTED_ROUTES = ['/checkout', '/order-confirmation']

export const LEGAL_AGE_BY_PROVINCE = {
  AB: 18,
  BC: 19,
  MB: 18,
  NB: 19,
  NL: 19,
  NT: 18,
  NS: 19,
  NU: 19,
  ON: 19,
  PE: 21,
  QC: 18,
  SK: 18,
  YT: 19
}

export const CART_SUMMARY_HEIGHT_MOBILE = '78px'
export const CART_SUMMARY_HEIGHT_DESKTOP = '130px'

export const TOAST_DURATION_MS = 3000

export const ACCESSORIES = {
  'vype-epod-vape': {
    handle: 'epod-accessories',
    skins: true
  },
  'vype-epen-3': {
    handle: '',
    skins: false
  }
}

export const CARTRIDGES = {
  'vype-epod-vpro-cartridges': {
    title: 'ePOD',
    pageHandle: 'vype-epod-vpro-cartridges'
  },
  'vype-epen-3-cartridges-vpro': {
    title: 'ePEN',
    pageHandle: 'vype-epen-3-cartridges'
  },
  'vype-epod-vape': {
    handle: 'vype-epod-vpro-cartridges',
    packName: '2 cartridges',
    tabs: [
      {
        name: 'vPro',
        handle: ''
      }
    ]
  },
  'vype-epen-3': {
    query: "title:'Vype ePen 3 Cartridges - Freebase' OR 'Vype ePen 3 Cartridges - vPro'",
    handle: 'vype-epen-3-cartridges',
    packName: '2 cartridges',
    tabs: [
      {
        name: 'All',
        handle: ''
      },
      {
        name: 'vPro',
        handle: 'vype-epen-3-cartridges-vpro'
      },
      {
        name: 'Nicotine-free',
        handle: 'vype-epen-3-cartridges-freebase'
      }
    ]
  }
}

export const STORE_LOCATOR_OPTIONS = {
  logo: 'https://cdn.shopify.com/s/files/1/2727/5392/files/logo.png?12776652579441201003',
  name: 'vype',
  colors: {
    primary: '#16191c',
    secondary: '#EE3840'
  }
}

export const SLIDESHOW_SPEED = '700ms'

export const SWATCH_COLOR_FOR_OPTION_NAME = {
  red: '#D72A3D',
  blue: '#407896',
  purple: '#4b4271',
  gold: '#D5A73E',
  black: '#000',
  chrome: '#92949A',
  white: '#FFFFFF',
  graphite: '#6f746f',
  'rose gold': '#f5c9c0',
  matblack: '#a2acab',
  silver: '#a2acab',
  aqua: '#3B9B94',
  '50hz - black': '#000',
  '50hz - graphite': '#6f746f',
  '50hz - rose gold': '#f5c9c0',
  '1728hz - black': '#000',
  '1728hz - graphite': '#6f746f',
  '1728hz - rose gold': '#f5c9c0',
  '1453hz - black': '#000',
  '1453hz - graphite': '#6f746f',
  '1453hz - rose gold': '#f5c9c0'
}

export const SETTINGS_FOR_PRODUCT_NAME = {
  'lychee-orchard': {
    gradient: 'linear-gradient(110.85deg, #C13930 -7.61%, #B33C36 115.55%), #DE4448',
    name: 'Lychee',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 5
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'passionfruit-fields': {
    gradient: 'linear-gradient(110.85deg, #7B2783 -7.61%, #551E53 115.55%), #A55199',
    name: 'Passionfruit',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 5
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'infused-cucumber': {
    gradient: 'linear-gradient(110.85deg, #589B75 -7.61%, #023A1A 113.2%), #67A481',
    name: 'Cucumber',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'infused-cucumber-epod-cartridge': {
    gradient: 'linear-gradient(110.85deg, #589B75 -7.61%, #023A1A 113.2%), #67A481',
    name: 'Cucumber',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'garden-strawberry-epod-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'mango-wonder-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'epod-mango-wonder-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'tobacco-marvel-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Golden Tobacco',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'epod-nicotine-salts-tobacco-marvel-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Golden Tobacco',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'smooth-tobacco': {
    gradient: 'linear-gradient(160.31deg, #D6AB71 -25.73%, #492A21 110.6%), #CDA16A',
    name: 'Smooth Tobacco',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 2
      }
    ],
    ontarioTag: 'New',
    refillsTag: 'New'
  },
  'aromatic-tobacco': {
    gradient: 'linear-gradient(113.38deg, #B69552 -13.34%, #362811 116.6%), #7E5F2C',
    name: 'Aromatic Tobacco',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ],
    ontarioTag: 'New',
    refillsTag: 'New'
  },
  'rich-tobacco': {
    gradient: 'linear-gradient(109.83deg, #A0784E -22.45%, #3E271E 108.62%), #3D221C',
    name: 'Rich Tobacco',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 5
      },
      {
        label: 'Complexity',
        value: 5
      },
      {
        label: 'Round Body',
        value: 5
      }
    ],
    ontarioTag: 'New',
    refillsTag: 'New'
  },
  peppermint: {
    gradient: 'linear-gradient(109.05deg, #008066 -14.41%, #004031 107.54%), #007B62',
    name: 'Cool Peppermint',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ],
    ontarioTag: 'New',
    refillsTag: 'New'
  },
  'creamy-mint': {
    gradient: 'linear-gradient(107.58deg, #86C9B8 -20.31%, #3F886C 105.96%), #77BCA4',
    name: 'Smooth Mint',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 3
      },
      {
        label: 'Round Body',
        value: 5
      }
    ],
    ontarioTag: 'New',
    refillsTag: 'New'
  },
  peach: {
    gradient: 'linear-gradient(108.77deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 3
      },
      {
        label: 'Round Body',
        value: 4
      }
    ],
    ontarioTag: 'New',
    refillsTag: 'New'
  },
  'vanilla-medley-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'epod-nicotine-salts-vanilla-medley': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'epen-3-cartridge-infused-vanilla': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla'
  },
  'polar-mint-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Polar Mint',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'epod-vpro-cartridges-polar-mint': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Polar Mint',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'crisp-mint-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'crushed-mint-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'berry-blast-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #B15B6B -7.61%, #8D2E41 115.55%), #5F1221',
    name: 'Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'vype-pods-berry-blast-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #B15B6B -7.61%, #8D2E41 115.55%), #5F1221',
    name: 'Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'berry-blast': {
    gradient: 'linear-gradient(110.85deg, #B15B6B -7.61%, #8D2E41 115.55%), #5F1221',
    name: 'Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'garden-strawberry': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'original-strawberry-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry'
  },
  'blood-orange': {
    gradient: 'linear-gradient(110.85deg, #EC6A4C -7.61%, #B33C36 115.55%), #E5995B',
    name: 'Blood Orange',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'blood-orange-epod-cartridge': {
    gradient: 'linear-gradient(110.85deg, #EC6A4C -7.61%, #B33C36 115.55%), #E5995B',
    name: 'Blood Orange',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'classic-tobacco-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D5783E -7.61%, #934924 115.55%), #934924',
    name: 'Classic Tobacco'
  },
  'discovery-pack-epen-3-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #222 -7.61%, #333 115.55%), #333',
    name: 'Discovery'
  },
  'fresh-apple-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #7AA85A -7.61%, #295924 113.2%), #C0D994',
    name: 'Apple'
  },
  'vype-epen3-pods-fresh-apple-cartridge': {
    gradient: 'linear-gradient(110.85deg, #7AA85A -7.61%, #295924 113.2%), #C0D994',
    name: 'Apple'
  },
  'fresh-apple-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #7AA85A -7.61%, #295924 113.2%), #C0D994',
    name: 'Apple'
  },
  'infused-vanilla-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla'
  },
  'infused-vanilla-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla'
  },
  'dark-cherry-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #AD2E72 -7.61%, #5C143A 115.55%), #A55199',
    name: 'Cherry'
  },
  'vype-epen3-dark-cherry-cartridge': {
    gradient: 'linear-gradient(110.85deg, #AD2E72 -7.61%, #5C143A 115.55%), #A55199',
    name: 'Cherry'
  },
  'dark-cherry-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #AD2E72 -7.61%, #5C143A 115.55%), #A55199',
    name: 'Cherry'
  },
  'strawberry-smash-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry'
  },
  'epen-3-vape-pods-strawberry-smash': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry'
  },
  'blended-tobacco-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Classic Tobacco'
  },
  'golden-tobacco-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Classic Tobacco'
  },
  'epen-3-golden-tobacco-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Classic Tobacco'
  },
  'crushed-mint-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'vape-pods-crushed-mint-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'classic-peach-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'classic-peach-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'peach-whirl-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'epen-3-cartridge-peach-whirl': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'ripe-mango-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango'
  },
  'tropical-mango-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango'
  },
  'epen-3-cartridge-indigo-dive': {
    gradient: 'linear-gradient(110.85deg, #7072B5 -7.61%, #7072B5 115.55%), #7072B5',
    name: 'Indigo Dive'
  },
  'epen3-cartridge-scarlet-kick-berries': {
    gradient: 'linear-gradient(110.85deg, #A95A7B -7.61%, #A95A7B 115.55%), #A95A7B',
    name: 'Scarlet Kick'
  },
  'green-snap-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #0D8787 -7.61%, #0D8787 115.55%), #0D8787',
    name: 'Green Snap'
  },
  watermelon: {
    gradient: 'linear-gradient(116.87deg, #D14441 -7.61%, #F19285 115.55%), #F2968A',
    name: 'Watermelon',
    ontarioTag: 'New',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  blueberry: {
    gradient: 'linear-gradient(116.87deg, #A296C9 -7.61%, #4D4384 113.2%), #4F4485',
    name: 'Blueberry',
    ontarioTag: 'New',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 3
      },
      {
        label: 'Round Body',
        value: 5
      }
    ]
  },
  'lemon-berry': {
    gradient: 'linear-gradient(110.67deg, #FFB3F7 -43.97%, #FFE344 111.93%), #FEDC00',
    name: 'Lemon Berry',
    ontarioTag: 'New',
    refillsTag: 'New',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  clear: {
    gradient: 'linear-gradient(115.99deg, #DCDCDC -7.61%, #CCCCCC 113.2%), #D4D4D4',
    name: 'Clear',
    ontarioTag: 'New',
    refillsTag: 'New',
    isDark: true
  },
  'epod-charger': {
    thumbnail: 'images/accessories/charger.jpg'
  },
  'the-pouch': {
    thumbnail: 'images/accessories/pouch.jpg'
  },
  plates: {
    gradient: 'linear-gradient(111.17deg, #91b820 1.13%, #e9894a 45.39%, #ee649f 102.29%)'
  },
  plate: {
    gradient: 'linear-gradient(111.17deg, #91b820 1.13%, #e9894a 45.39%, #ee649f 102.29%)'
  },
  halftone: {
    gradient: 'linear-gradient(111.17deg, #EDB906 1.13%, #51B7E0 45.39%, #313E8A 102.29%)'
  },
  umbra: {
    gradient: 'linear-gradient(111.17deg, rgba(224, 70, 95, 0.5) 1.13%, #7760AB 45.39%, #39374C 102.29%)'
  },
  tikiti: {
    gradient: 'linear-gradient(111.17deg, #E68070 1.13%, #E48790 45.39%, #259C74 102.29%)'
  },
  sway: {
    gradient: 'linear-gradient(111.17deg, #73CAEB 1.13%, #469CA8 45.39%, #14273C 102.29%)'
  },
  marmor: {
    gradient: 'linear-gradient(111.17deg, #708586 6.93%, #837A76 41.7%, #4E556F 66.99%, #BF3927 96.5%)'
  },
  foil: {
    gradient: 'linear-gradient(111.17deg, #6C6C6C 1.13%, #BFB7A7 45.39%, #3B3936 102.29%)'
  },
  fabrica: {
    gradient: 'linear-gradient(111.17deg, #0E0F0C 1.13%, #E7B580 45.39%, #EC8D2D 102.29%)'
  },
  holographic: {
    gradient: `url(${process.env.BASE_PATH}/images/skins/holographic-bg.jpg)`
  }
}

export const ALLOWED_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'ON', 'PE', 'SK']

export const CANADIAN_PROVINCES = [
  {
    label: 'Alberta',
    value: 'AB'
  },
  {
    label: 'British Columbia',
    value: 'BC'
  },
  {
    label: 'Manitoba',
    value: 'MB'
  },
  {
    label: 'New Brunswick',
    value: 'NB'
  },
  {
    label: 'Saskatchewan',
    value: 'SK'
  },
  {
    label: 'Ontario',
    value: 'ON'
  },
  {
    label: 'Prince Edward Island',
    value: 'PE'
  },
  {
    label: 'Newfoundland and Labrador',
    value: 'NL'
  },
  {
    label: 'Quebec',
    value: 'QC'
  }
]

export const POSTAL_CODE_START_BY_PROVINCE = {
  AB: ['T'],
  BC: ['V'],
  MB: ['R'],
  NB: ['E'],
  NL: ['A'],
  NT: ['X'],
  NS: ['B'],
  NU: ['X'],
  ON: ['K', 'L', 'M', 'N', 'P'],
  PE: ['C'],
  QC: ['G', 'H', 'J'],
  SK: ['S'],
  YT: ['Y']
}

export const TIERS_TRESHOLDS = {
  silver: 100,
  gold: 250,
  platinum: 400
}

export const TIERS_BENEFITS = {
  silver: ['Free shipping on all orders', 'Birthday gift'],
  gold: ['Free shipping on all orders', 'Birthday gift', '<strong>Early access</strong> to new flavours'],
  platinum: [
    '<strong>Free express shipping</strong> on all orders',
    'Birthday gift',
    '<strong>Early access</strong> to new product and flavours'
  ]
}

export const INITIAL_ENGRAVING = {
  front: {
    pattern: {
      value: '',
      name: '',
      collection: '',
      displayName: 'Pattern',
      slug: 'pattern'
    },
    miniIcon: {
      value: '',
      name: '',
      displayName: 'Mini Icon',
      slug: 'icon'
    },
    text: {
      value: '',
      orientation: 'horizontal',
      font: 'Abebedera',
      displayName: 'Text',
      slug: 'text'
    },
    proceeded: false
  },
  back: {
    text: {
      value: '',
      orientation: 'horizontal',
      font: 'Abebedera',
      displayName: 'Text',
      slug: 'text'
    },
    proceeded: false
  },
  box: {
    text: {
      value: '',
      displayName: 'your name'
    },
    proceeded: false
  },
  proceeded: false
}

export const ENGRAVING_PATTERNS = [
  {
    collection: 'New',
    isNew: true,
    patterns: [
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/new/flare.svg`, name: 'Flare' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/new/rhombus.svg`, name: 'Rhombus' }
    ]
  },
  {
    collection: 'Solstice',
    patterns: [
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/solstice/grove.svg`, name: 'Grove' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/solstice/hoya.svg`, name: 'Hoya' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/solstice/kombu.svg`, name: 'Kombu' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/solstice/palma.svg`, name: 'Palma' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/solstice/taro.svg`, name: 'Taro' }
    ]
  },
  {
    collection: 'Fabrichromatic',
    patterns: [
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/fabrichromatic/alcove.svg`, name: 'Alcove' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/fabrichromatic/herring.svg`, name: 'Herring' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/fabrichromatic/minos.svg`, name: 'Minos' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/fabrichromatic/paragon.svg`, name: 'Paragon' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/fabrichromatic/spoked.svg`, name: 'Spoked' }
    ]
  },
  {
    collection: 'Scrapes',
    patterns: [
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/scapes/code.svg`, name: 'Code' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/scapes/flux.svg`, name: 'Flux' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/scapes/inked.svg`, name: 'Inked' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/scapes/stencil.svg`, name: 'Stencil' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/scapes/tag.svg`, name: 'Tag' }
    ]
  },
  {
    collection: 'Abstractions',
    patterns: [
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/abstractions/circuit.svg`, name: 'Circuit' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/abstractions/eclipse.svg`, name: 'Eclipse' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/abstractions/format.svg`, name: 'Format' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/abstractions/mural.svg`, name: 'Mural' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/abstractions/trace.svg`, name: 'Trace' }
    ]
  }
]

export const ENGRAVING_MINI_ICONS = [
  { value: `${process.env.BASE_PATH}/images/engraving/icons/bolt.svg`, name: 'Bolt', isNew: true },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/radial.svg`, name: 'Radial', isNew: true },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/st-patrick.svg`, name: 'St-Patrick' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/aster.svg`, name: 'Aster' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/augusta.svg`, name: 'Augusta' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/axiom.svg`, name: 'Axiom' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/classic.svg`, name: 'Classic' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/corsage.svg`, name: 'Corsage' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/cosmo.svg`, name: 'Cosmo' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/equinox.svg`, name: 'Equinox' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/light.svg`, name: 'Light' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/lozenge.svg`, name: 'Lozenge' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/lotus.svg`, name: 'Lotus' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/nopal.svg`, name: 'Nopal' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/nova.svg`, name: 'Nova' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/optic.svg`, name: 'Optic' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/passage.svg`, name: 'Passage' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/planta.svg`, name: 'Planta' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/solar.svg`, name: 'Solar' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/spectra.svg`, name: 'Spectra' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/tidal.svg`, name: 'Tidal' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/tropics.svg`, name: 'Tropics' },
  { value: `${process.env.BASE_PATH}/images/engraving/icons/zuma.svg`, name: 'Zuma' }
]

export const ALLOWED_BUYFLOW_ROUTES = [
  'epod',
  'epen-3',
  'epod-devices',
  'engravable',
  'epod-starter-kit',
  'limited-edition-box-sets',
  'limited-edition-epod'
]

export const PATHS_WITHOUT_SOFT_AV = ['/account/email-verification', '/create-password', '/qc']

export const OOS_QTY_THRESHOLD = 10 // If the quantity for a variant in a province is less than this constant, we mark it as out of stock
